export { ClinicalSummaryCard } from './ClinicalSummaryCard';
export { PatientAdmissionsTab } from './PatientAdmissionsTab';
export { PatientAllergyTab } from './PatientAllergyTab';
export { PatientConsumableTab } from './PatientConsumableTab';
